import { useForm } from "@core/features/form";
import { useForgotPassword } from "@core/features/auth";
import { usePlatformStore } from "@platform/store";
import { ForgotPasswordForm } from "./ForgotPasswordForm";

type Props = {
  onError?: () => void;
  onSuccess?: () => void;
  /** Render prop for custom actions (submit button, etc.) */
  renderActions?: (props: {
    isSubmitting: boolean;
    isValid: boolean;
    isSuccess: boolean;
    onSubmit: () => Promise<void>;
  }) => React.ReactNode;
};

export function ForgotPasswordFormContainer({
  onError,
  onSuccess,
  renderActions,
}: Props) {
  const clearAuth = usePlatformStore((s) => s.clearAuth);

  const handleError = () => {
    clearAuth();
    onError?.();
  };

  const { forgotPasswordMutation, isSuccess, schema, defaultValues } =
    useForgotPassword({
      onError: handleError,
      onSuccess,
    });

  const { form, handleSubmit } = useForm({
    schema,
    onSubmit: forgotPasswordMutation.mutateAsync,
    defaultValues,
  });

  const { isSubmitting, isValid } = form.formState;

  return (
    <>
      {!isSuccess && <ForgotPasswordForm form={form} />}
      {renderActions?.({
        isSubmitting,
        isValid,
        isSuccess,
        onSubmit: handleSubmit,
      })}
    </>
  );
}

export default ForgotPasswordFormContainer;
